import React from 'react';
import { useTranslation } from 'react-i18next';
import { ToggleActionIcon } from './ToggleActionIcon';
import SvgWatchLater from '../../../../../play-core/icons/WatchLater';
import SvgWatchLaterOutline from '../../../../../play-core/icons/WatchLaterOutline';
import { useDataDispatch } from '../../../providers/DataProvider/DataContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const WatchLaterAction = ({
  isAdded,
  isHovering = true,
  mediaUrn,
  showUndo
}) => {
  const dataDispatch = useDataDispatch();
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsx(ToggleActionIcon, {
    isHovering: isHovering,
    onClick: () => dataDispatch({
      type: 'toggle-watch-later',
      urn: mediaUrn,
      showUndo
    }),
    activeIcon: /*#__PURE__*/_jsx(SvgWatchLater, {}),
    ariaTitle: t('global.watchLater'),
    inactiveIcon: /*#__PURE__*/_jsx(SvgWatchLaterOutline, {}),
    isActive: isAdded
  });
};